export const ACTION_GET_CATEGORIES_BENEFITS_MARKETPLACE = "ACTION_GET_CATEGORIES_BENEFITS_MARKETPLACE";
export const ACTION_GET_CATEGORIES_MARKETPLACE = "ACTION_GET_CATEGORIES_MARKETPLACE";
export const ACTION_GET_CATEGORY_TYPE_MARKETPLACE = "ACTION_GET_CATEGORY_TYPE_MARKETPLACE";
export const ACTION_GET_SUBCATEGORIES_MARKETPLACE = "ACTION_GET_SUBCATEGORIES_MARKETPLACE";
export const ACTION_POST_CREATE_CATEGORIES_MARKETPLACE = 'ACTION_POST_CREATE_CATEGORIES_MARKETPLACE';
export const ACTION_PUT_UPDATE_CATEGORIES_MARKETPLACE = 'ACTION_PUT_UPDATE_CATEGORIES_MARKETPLACE';  
export const ACTION_DELETE_DELETE_CATEGORIES_MARKETPLACE = 'ACTION_DELETE_DELETE_CATEGORIES_MARKETPLACE';
export const ACTION_POST_CREATE_SUBCATEGORIES_MARKETPLACE = 'ACTION_POST_CREATE_SUBCATEGORIES_MARKETPLACE';
export const ACTION_PUT_UPDATE_SUBCATEGORIES_MARKETPLACE = 'ACTION_PUT_UPDATE_SUBCATEGORIES_MARKETPLACE';
export const ACTION_DELETE_DELETE_SUBCATEGORIES_MARKETPLACE = 'ACTION_DELETE_DELETE_SUBCATEGORIES_MARKETPLACE';
export const ACTION_GET_MODE_MARKETPLACE = "ACTION_GET_MODE_MARKETPLACE";
export const ACTION_GET_CATEGORIES_ID_MARKETPLACE = "ACTION_GET_CATEGORIES_ID_MARKETPLACE";


